import { render, staticRenderFns } from "./TruckOrderList.vue?vue&type=template&id=5cb4eb03&scoped=true"
import script from "./TruckOrderList.vue?vue&type=script&lang=ts"
export * from "./TruckOrderList.vue?vue&type=script&lang=ts"
import style0 from "./TruckOrderList.vue?vue&type=style&index=0&id=5cb4eb03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4eb03",
  null
  
)

export default component.exports